import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function ConfirmModal({
  onClick,
  title: title_,
  confirmMessage,
  okLabel,
  cancelLabel: cancelLabel_,
  open,
  handleCancel,
  okButtonColor,
  okButtonVariant = 'outlined',
}) {
  const { t } = useTranslation('translation');
  const title = title_ ?? t('confirm-modal.title');
  const cancelLabel = cancelLabel_ ?? t('confirm-modal.cancel');

  const [loading, setLoading] = useState(false);
  const handleClick = useCallback(async () => {
    setLoading(true);
    await onClick();
    setLoading(false);
  }, [onClick]);

  return (
    <Dialog open={open} onClose={handleCancel}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Typography>{confirmMessage}</Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancel}>{cancelLabel}</Button>
        <LoadingButton
          onClick={handleClick}
          variant={okButtonVariant}
          color={okButtonColor}
          loading={loading}
        >
          {okLabel}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
